<div class="query-folio" [class.full-size]="!params?.id">
  <div class="contipo">
    <div class="main-portfolio" *ngIf="queryApi.querys">
      <ng-container>
        <ng-template #loading>
          <div class="loading">
            <mat-spinner [diameter]="50"></mat-spinner>
          </div>
        </ng-template>
        <ng-container *ngIf="items; else loading">
          <section class="query-empty" *ngIf="!params?.id">
            <mat-icon class="qe-icon">view_module</mat-icon>
            <div class="qe-title">No collections yet</div>
            <p class="qe-text">
              A collection groups Boolean queries on topics, events, companies
              and people, so you can follow them side by side.
            </p>
            <div class="qe-actions">
              <button class="qe-primary" (click)="iCreate()">
                <mat-icon>add</mat-icon>Create collection
              </button>
              <button class="qe-secondary" (click)="loadSampleCollections()">
                Pre-load sample collections
              </button>
              <button
                class="qe-secondary"
                (click)="collectionFileInput.click()"
              >
                Import collections (from files)
              </button>
              <input
                #collectionFileInput
                class="inptfile"
                type="file"
                accept=".json"
                value=""
                (click)="collectionFileInput.value = null"
                (change)="iImport($event, 'collection')"
                multiple
              />
            </div>
          </section>

          <section class="query-list data-list" *ngIf="params?.id">
            <header class="dl-header">
              <div>
                <div class="dl-title">Queries</div>
                <div class="dl-subtitle">
                  Number of queries: {{ items.length }}
                </div>
                <div class="dl-subtitle" *ngIf="isOther">
                  These queries are in no collection. Edit one to add it to a
                  collection.
                </div>
              </div>
              <div class="dl-header-actions">
                <button
                  class="dl-icon-btn visible"
                  [matMenuTriggerFor]="collectionMenu"
                  matTooltip="Import and export"
                  aria-label="Import and export"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <button class="dl-add-btn" *ngIf="!isOther" (click)="iQuery()">
                  <mat-icon>add</mat-icon>New query
                </button>
              </div>
              <mat-menu #collectionMenu="matMenu" xPosition="before">
                <ng-container *ngIf="!isOther">
                  <button mat-menu-item (click)="iImport(null, 'query')">
                    Import saved queries
                  </button>
                  <button mat-menu-item (click)="queryFileInput.click()">
                    Import queries from files
                  </button>
                  <button mat-menu-item (click)="iExport('collection')">
                    Export collection (json)
                  </button>
                </ng-container>
                <button
                  mat-menu-item
                  [disabled]="!itemsLoaded"
                  (click)="iExport('stats')"
                >
                  Export statistics (xlsx)
                </button>
              </mat-menu>
              <input
                #queryFileInput
                class="inptfile"
                type="file"
                accept=".json"
                value=""
                (click)="queryFileInput.value = null"
                (change)="importQueryFiles($event)"
                multiple
              />
            </header>

            <div class="ql-grid dl-head">
              <button
                class="dl-sort"
                [class.active]="isSorted('abc')"
                (click)="goSort('abc')"
                matTooltip="Alphabetic Order"
                matTooltipPosition="above"
              >
                Query{{ arrow('abc') }}
              </button>
              <button
                class="dl-sort"
                [class.active]="isSorted('count')"
                (click)="goSort('count')"
                matTooltip="Total number of news articles"
                matTooltipPosition="above"
              >
                Vol{{ arrow('count') }}
              </button>
              <button
                class="dl-sort"
                [class.active]="isSorted('ratio')"
                (click)="goSort('ratio')"
                matTooltip="The relative change in the total number of news articles from the previous period"
                matTooltipPosition="above"
              >
                ΔVol{{ arrow('ratio') }}
              </button>
              <button
                class="dl-sort"
                [class.active]="isSorted('senti')"
                (click)="goSort('senti')"
                matTooltip="Sentiment Rating where 0% is very negative and 100% is very positive"
                matTooltipPosition="above"
              >
                Sent{{ arrow('senti') }}
              </button>
              <button
                class="dl-sort"
                [class.active]="isSorted('trend')"
                (click)="goSort('trend')"
                matTooltip="Change in the sentiment for the period"
                matTooltipPosition="above"
              >
                ΔSent{{ arrow('trend') }}
              </button>
              <span></span>
            </div>

            <div class="ql-body">
              <div class="ql-empty" *ngIf="items.length === 0">
                <span>This collection has no queries yet.</span>
                <button mat-stroked-button (click)="iQuery()">
                  Create a query
                </button>
              </div>
              <div
                class="ql-grid dl-row"
                *ngFor="
                  let item of items | orderBy: myOrder;
                  trackBy: trackByUid
                "
                [class.active]="params.newsfeedFromQuery === item.query.uid"
                [class.pinned]="pinnedUid === item.query.uid"
                (click)="addTag(item)"
              >
                <div class="ql-name-cell">
                  <app-data-list-name
                    [name]="item.query.name"
                    (navigate)="iChart(item)"
                  ></app-data-list-name>
                </div>
                <ng-container *ngIf="item.sentiment; else pending">
                  <span class="dl-cell" [class]="cellTone('count', item)">{{
                    item.sentiment.count
                  }}</span>
                  <span class="dl-cell" [class]="cellTone('ratio', item)"
                    >×{{ item.sentiment.volume_ratio | round: 2 }}</span
                  >
                  <span class="dl-cell" [class]="cellTone('senti', item)">{{
                    item.sentiment.sentiment | percent
                  }}</span>
                  <span class="dl-cell" [class]="cellTone('trend', item)"
                    >{{ item.sentiment.sentiment_delta * 100 | round | trend
                    }}{{
                      item.sentiment.sentiment_delta * 100 | round | negative
                    }}</span
                  >
                </ng-container>
                <ng-template #pending>
                  <span class="ql-pending">
                    <mat-spinner
                      *ngIf="!itemsLoaded"
                      [diameter]="16"
                    ></mat-spinner>
                    <span *ngIf="itemsLoaded">No data</span>
                  </span>
                </ng-template>
                <div class="dl-actions">
                  <button
                    class="dl-icon-btn"
                    (click)="$event.stopPropagation(); iEdit(item)"
                    matTooltip="Edit query"
                    aria-label="Edit query"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    class="dl-icon-btn"
                    [matMenuTriggerFor]="rowMenu"
                    [matMenuTriggerData]="{ item: item }"
                    (click)="$event.stopPropagation()"
                    aria-label="Query actions"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <mat-menu #rowMenu="matMenu" xPosition="before">
              <ng-template matMenuContent let-item="item">
                <button mat-menu-item (click)="duplicateQuery(item)">
                  Duplicate
                </button>
                <button mat-menu-item (click)="exportQuery(item)">
                  Export (json)
                </button>
                <button
                  mat-menu-item
                  class="dl-menu-danger"
                  (click)="deleteQuery(item)"
                >
                  Delete
                </button>
              </ng-template>
            </mat-menu>
          </section>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
